import { isNativeApp } from './native';
import { DispatchAlert } from './dispatchAlertNative';

function playWebDispatchTone(): void {
  try {
    const AudioContextClass = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (!AudioContextClass) return;

    const ctx = new AudioContextClass();
    const startTones = () => {
      const playTone = (freq: number, duration: number, delayMs: number) => {
        setTimeout(() => {
          try {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.frequency.value = freq;
            osc.type = 'square';
            gain.gain.setValueAtTime(0.3, ctx.currentTime);
            gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration);
            osc.start(ctx.currentTime);
            osc.stop(ctx.currentTime + duration);
          } catch {
            // ignore
          }
        }, delayMs);
      };

      playTone(880, 0.15, 0);
      playTone(660, 0.15, 200);
      playTone(880, 0.15, 400);
      playTone(660, 0.15, 600);
      setTimeout(() => {
        playTone(880, 0.15, 0);
        playTone(660, 0.15, 200);
        playTone(880, 0.15, 400);
        playTone(660, 0.15, 600);
        setTimeout(() => {
          try {
            ctx.close();
          } catch {
            // ignore
          }
        }, 800);
      }, 1200);
    };

    if (ctx.state === 'suspended') {
      void ctx.resume().then(startTones).catch(startTones);
    } else {
      startTones();
    }
  } catch {
    // ignore
  }
}

/** Call once after a user gesture (e.g. Start shift) so later alerts can play audio. */
export async function unlockDispatchAudio(): Promise<void> {
  try {
    const AudioContextClass = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (!AudioContextClass) return;
    const ctx = new AudioContextClass();
    if (ctx.state === 'suspended') {
      await ctx.resume();
    }
    await ctx.close();
  } catch {
    // ignore
  }
}

/** Register Android dispatch channel (alarm stream, bypass DND when permitted). */
export async function ensureDispatchAlertChannel(): Promise<void> {
  if (!isNativeApp()) return;
  try {
    await DispatchAlert.ensureDispatchChannel();
  } catch {
    // Native plugin only in store Android build
  }
}

/** Play dispatch alert — alarm stream on native Android; web tone elsewhere. */
export async function playDispatchAlertSound(): Promise<void> {
  try {
    if (navigator.vibrate) {
      navigator.vibrate([300, 100, 300, 100, 600]);
    }
  } catch {
    // ignore
  }

  if (isNativeApp()) {
    try {
      await DispatchAlert.playAlarm();
      return;
    } catch {
      // fall through to web tone
    }
  }

  playWebDispatchTone();
}

export async function stopDispatchAlertSound(): Promise<void> {
  if (!isNativeApp()) return;
  try {
    await DispatchAlert.stopAlarm();
  } catch {
    // ignore
  }
}
